import { FC } from "react";
import { QuantityManager } from "../product-selector/components/quantity-manager";
import { useProductCardSelectorLogic } from "./product-card-selector.hooks";
import { ProductCardSelectorProps } from "./product-card-selector.types";
import Button from "./variations/button";

const ProductCardSelector: FC<ProductCardSelectorProps> = ({
  className,
  product,
  offerId,
  selectedToppings,
  shouldNavigate,
  cartProducts,
  addProduct,
  removeProduct,
  manuallyChangeProduct,
  theme,
  storeMetadata,
  isChat
}) => {
  const {
    hasProductInTheCart,
    handleBuyButtonClick,
    canProductToBeAdded,
    productIsInventoryAvailable,
  } = useProductCardSelectorLogic({
    product,
    offerId,
    addProduct,
    removeProduct,
    manuallyChangeProduct,
    cartProducts,
    theme,
    storeMetadata,
  });

  return (
    <div className={className}>
      {hasProductInTheCart ? (
        <QuantityManager
          product={product}
          offerId={offerId}
          cartProducts={cartProducts}
          addProduct={addProduct}
          removeProduct={removeProduct}
          manuallyChangeProduct={manuallyChangeProduct}
          theme={theme}
        />
      ) : (
        <Button
          productType={product.type}
          isDisabled={!canProductToBeAdded(selectedToppings) || !productIsInventoryAvailable}
          theme={theme}
          onClick={() =>
            handleBuyButtonClick(selectedToppings, shouldNavigate, isChat ? storeMetadata.userNetwork.urlSummer : "")
          }
        />
      )}
    </div>
  );
};

export default ProductCardSelector;
